import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { InlineAlert } from "../../../components/InlineAlert";
import { LoadingButton } from "../../../components/LoadingButton";
import { LoadingTextButton } from "../../../components/LoadingTextButton";
import { PageFooterWrapper } from "../../../components/PageFooterWrapper";
import {
  type FooterActionCallbacks,
  type FooterDataProps,
  getFooterContent,
} from "./utils/getFooterContent";

interface PastShiftDetailsFooterProps extends FooterDataProps {
  actions: FooterActionCallbacks;
}

export function PastShiftDetailsFooter(props: PastShiftDetailsFooterProps) {
  const { actions, ...footerDataProps } = props;

  const content = getFooterContent(footerDataProps, actions);

  if (!isDefined(content)) {
    return null;
  }

  return (
    <PageFooterWrapper withShadow sx={content.wrapperSx}>
      <Stack spacing={4} alignItems="center">
        {isDefined(content.alertTitle) && (
          <InlineAlert
            iconType="triangle-exclamation"
            iconColor={(theme) => theme.palette.intent?.error.text}
            title={content.alertTitle}
            titleColor={(theme) => theme.palette.intent?.error.text}
            description={content.description}
            descriptionVariant={content.descriptionVariant}
          />
        )}

        {!isDefined(content.alertTitle) && (
          <Text
            semibold
            variant={content.descriptionVariant}
            align="center"
            sx={{ color: "text.secondary" }}
          >
            {content.description}
          </Text>
        )}

        <LoadingButton
          fullWidth
          disabled={content.primaryButtonDisabled}
          isLoading={content.isPrimaryButtonLoading ?? false}
          variant={content.primaryButtonVariant}
          size="large"
          startIconType={content.primaryButtonStartIconType}
          onClick={content.primaryButtonAction}
        >
          {content.primaryButtonLabel}
        </LoadingButton>

        {isDefined(content.secondaryButtonLabel) && isDefined(content.secondaryButtonAction) && (
          <LoadingTextButton
            size="medium"
            isLoading={content.isSecondaryButtonLoading ?? false}
            onClick={content.secondaryButtonAction}
          >
            {content.secondaryButtonLabel}
          </LoadingTextButton>
        )}
      </Stack>
    </PageFooterWrapper>
  );
}
